const isGenesis = window?.location.host.includes('localhost') || window?.location.host.includes('genesis.ffau.to');

export default isGenesis;
